import(/* webpackMode: "eager", webpackExports: ["TermlyPolicy","TermsAndConditionsPolicyDataId"] */ "/codebuild/output/src2907867774/src/apps/wrap.gifts/src/services/Termly/TermlyPolicy.tsx");
